import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

export async function createLead(payload) {
  const res = await fetch(`${API}/api/leads`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const err = await res.text();
    throw new Error(err || `Request failed (${res.status})`);
  }
  return res.json();
}

export async function fetchLeadStats() {
  const res = await fetch(`${API}/api/leads/stats`);
  if (!res.ok) throw new Error("Failed to load stats");
  return res.json();
}

// Fetch a slug from /api/content/{slug}. Returns `fallback` until the
// response lands, then swaps in the live admin-edited content. If the
// backend is unreachable we keep the fallback so the public site never
// looks broken.
export function useContent(slug, fallback) {
  const [data, setData] = useState(fallback);
  useEffect(() => {
    let cancelled = false;
    fetch(`${API}/api/content/${slug}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((doc) => {
        if (cancelled) return;
        const live = doc?.data;
        if (live == null) return;
        // Treat empty arrays / empty singleton objects as "nothing set yet" → keep fallback.
        if (Array.isArray(live) && live.length === 0) return;
        if (!Array.isArray(live) && typeof live === "object" && Object.keys(live).length === 0) return;
        setData(live);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [slug]);
  return data;
}
